export default __webpack_public_path__ + "static/media/holder001.2b0b6f7b.jpg";